{{ "common.show_per_page" | translate }} @for (pageSizeOption of pageSizeOptions; track pageSizeOption) {
<span tabindex="0" role="button" class="page-size-options__page-size-option" (keydown)="onKeydown($event, pageSizeOption)" (click)="pageSizeOptionClick.emit(pageSizeOption)">{{ pageSizeOption }}</span>
}



